<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg3441"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs3445"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath3455"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path3453" /></clipPath></defs><g
     id="g3447"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g3449"><g
         id="g3451"
         clip-path="url(#clipPath3455)"><g
           id="g3457"
           transform="translate(198.8902,136.043)"><path
             d="m 0,0 c 13.696,-69.014 74.573,-121.043 147.61,-121.043 30.199,0 58.315,8.901 81.882,24.213 l 61.383,-16.978 -16.978,61.383 c 15.312,23.567 24.213,51.683 24.213,81.882 0,73.037 -52.029,133.914 -121.043,147.61"
             style="stroke:#000000;stroke-width:30;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3459" /></g><g
           id="g3461"
           transform="translate(195.5,497)"><path
             d="m 0,0 c -99.687,0 -180.5,-80.813 -180.5,-180.5 0,-35.738 10.389,-69.049 28.307,-97.081 l -21.072,-76.184 76.184,21.072 C -69.048,-350.612 -35.738,-361 0,-361 c 99.687,0 180.5,80.813 180.5,180.5 C 180.5,-80.813 99.687,0 0,0 Z"
             style="stroke:#000000;stroke-width:30;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3463" /></g><path
           d="m 210.5,211 h -30 v 30 h 30 z"
           style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none"
           id="path3465" /><g
           id="g3467"
           transform="translate(150.5,362)"><path
             d="M 0,0 C 0,24.853 20.147,45 45,45 69.853,45 90,24.853 90,0 90,-13.15 84.357,-24.981 75.363,-33.208 L 45,-61 v -30"
             style="stroke:#000000;stroke-width:30;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3469" /></g></g></g></g></svg>
</template>
